var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrayageContainerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 66,
    viewBox: "0 0 61 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3896 31.6619H13.202L30.2952 18.2373L47.3896 31.6619ZM8.40256 38.7615H11.8191V58.891H8.40256V38.7615ZM16.4285 38.7615H19.845V58.891H16.4285V38.7615ZM24.4585 38.7615H27.875V58.891H24.4585V38.7615ZM32.4871 38.7615H35.9036V58.891H32.4871V38.7615ZM48.5443 38.7615H51.9608V58.891H48.5443V38.7615ZM0.148292 65.9906H60.45V31.6619H53.6499L34.1076 16.3146C34.8439 15.5307 35.3309 14.508 35.4338 13.3415L31.5924 13.0089C31.5356 13.6635 30.9339 14.0739 30.3084 14.0712C29.5971 14.0673 29.0138 13.4893 29.0138 12.7754C29.0138 12.072 29.572 11.4887 30.2793 11.4808L32.1928 11.4584V6.55199H33.4319V0.00927734H27.0819V6.55199H28.3197V8.01941C26.4049 8.81911 25.142 10.6903 25.142 12.7767C25.142 14.1359 25.6646 15.3671 26.5197 16.2869L6.94173 31.6619H0.146973L0.150932 48.8249L0.148292 65.9906ZM40.5144 38.7615H43.9309V58.891H40.5144V38.7615Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrayageContainerFilled);
export default __webpack_public_path__ + "static/media/drayage-container-filled.5560df29.svg";
export { ForwardRef as ReactComponent };